import { render } from "./ManageLabelSets.vue?vue&type=template&id=090399f4&scoped=true"
import script from "./ManageLabelSets.vue?vue&type=script&lang=js"
export * from "./ManageLabelSets.vue?vue&type=script&lang=js"

import "./ManageLabelSets.vue?vue&type=style&index=0&id=090399f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-090399f4"]])

export default __exports__